export function loadThemeByHost() {
    const host = window.location.hostname;

    const adsURL = `adsgroup.${process.env.VUE_APP_MANAGER_URL}`;

    if(host === adsURL) {
        return import("@/assets/css/app-saas-ads.css");
    } else {
        return import("@/assets/css/app-saas.css");
    }
}